import { render, staticRenderFns } from "./dictname.vue?vue&type=template&id=61825d76"
import script from "./dictname.vue?vue&type=script&lang=js"
export * from "./dictname.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports